export default class PatrolMarker {
  constructor(id, x, y, isLocked = false) {
    this.id = id;
    this.x = x;
    this.y = y;
    this.isLocked = isLocked;
  }

  toApi() {
    return {
      id: this.id,
      x: this.x,
      y: this.y,
      isLocked: this.isLocked,
    };
  }

  static fromApi(obj) {
    return new PatrolMarker(obj.id, obj.x, obj.y, obj.isLocked);
  }
}
